import React, { useEffect } from 'react';
import AccordionContent from './AccordionContent';


const Accordion = ({accordionData}) => {

    return (
        <>
            <div id="faqs"></div>   
            <section className="accordion-section">
                <h3 className="titles">RESPUESTAS ESPECíFICAS A LAS <span> DUDAS MáS COMUNES.</span></h3> 
                <div className="accordion">
                    {accordionData.map(({ title, content, para }) => (
                        <AccordionContent title={title} content={content}/>
                    ))}
                </div>
            </section>
        </>
      );
};

export default Accordion;